import PropTypes from 'prop-types'

import { getAssetLink } from '../../../../helpers/get-asset-link'

const COILink = ({ filePath, visitorName }) => {
  if (!filePath) {
    return <p>---</p>
  }

  const fileName = `${visitorName}_COI.pdf`

  const handleDownload = async () => {
    const link = getAssetLink({ path: 'vendor-coi', file: fileName })
    try {
      const response = await fetch(link)
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      const blob = await response.blob()
      const url = window.URL.createObjectURL(blob)
      const anchor = document.createElement('a')
      anchor.href = url
      anchor.download = fileName
      document.body.appendChild(anchor)
      anchor.click()
      window.URL.revokeObjectURL(url)
      document.body.removeChild(anchor)
    } catch (error) {
      console.error('There was a problem with the fetch operation:', error)
    }
  }

  return (
    <span onClick={handleDownload} className="coi-link">
      {fileName}
    </span>
  )
}

COILink.propTypes = {
  filePath: PropTypes.string,
  visitorName: PropTypes.string,
}

export default COILink
